export const SET_NEW_CONVERSATION_STATUS = 'SET_NEW_CONVERSATION_STATUS'
